var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-candidate-status" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "sm",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: { close: _vm.closeModal },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "div",
            { staticClass: "candidate__status-icon" },
            [
              _c("candidates-status-icon", {
                attrs: {
                  status: _vm.candidate.state,
                  "scheduled-time": {
                    date: _vm.candidate.statusDate,
                    time: _vm.candidate.statusTime,
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "svg",
            {
              staticClass: "m-candidate-status-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.closeModal },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-candidate-status-content" }, [
            _c("h3", { staticClass: "candidate__fullname" }, [
              _vm._v(_vm._s(_vm.candidate.fio)),
            ]),
            _c("div", { staticClass: "candidate__position" }, [
              _vm._v(_vm._s(_vm.candidate.post)),
            ]),
            _vm.candidate.filial
              ? _c("div", { staticClass: "candidate__filial" }, [
                  _vm._v(_vm._s(_vm.candidate.filial.filial_name)),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "candidate__status__wrapper" },
              [
                _c(
                  "div",
                  {
                    staticClass: "candidate__status",
                    style: _vm.backgroundColor,
                  },
                  [_vm._v(_vm._s(_vm.candidateStatus))]
                ),
                _vm.candidate.statusDate && _vm.candidate.statusTime
                  ? _c("candidates-scheduled-date", {
                      attrs: {
                        "status-id": _vm.candidate.status.id,
                        date: `${_vm.candidate.statusDate}\xa0${_vm.candidate.statusTime}`,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.candidate.accountable
              ? _c("div", { staticClass: "candidate__referral" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.candidate.accountable.photo || _vm.defaultAvatar,
                      alt: 404,
                    },
                    on: { error: _vm.replaceImageOnErrorLoad },
                  }),
                  _c("div", { on: { click: _vm.goToWorker } }, [
                    _vm._v(" " + _vm._s(_vm.candidate.accountable.name) + " "),
                  ]),
                ])
              : _vm._e(),
            _vm.candidate.status.reason
              ? _c("div", { staticClass: "candidate__rejection-reason" }, [
                  _vm._v(_vm._s(_vm.candidate.status.reason.name)),
                ])
              : _vm._e(),
            _vm.candidate.status.comment
              ? _c(
                  "div",
                  {
                    staticClass: "candidate__comment",
                    staticStyle: {
                      "text-overflow": "ellipsis",
                      "overflow-x": "hidden",
                    },
                  },
                  [_vm._v(_vm._s(_vm.candidate.status.comment))]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }